<template>
  <div class="container">
    <div class="handle-box">
      <span class="seller-filter-label">{{ $t('Status') }}：</span>
      <el-select v-model="sellerState" :placeholder="$t('Status')" class="seller-state-filter">
        <el-option :label="$t('all')" :value="0"></el-option>
        <el-option :label="$t('Enable')" :value="1"></el-option>
        <el-option :label="$t('Disable')" :value="2"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" class="mr10" @click="handleQuery(1)">{{ $t('Search') }}</el-button>
      <el-button type="primary" icon="el-icon-plus" class="mr10" @click="OnClickAddSeller()">{{ $t('newAddition') }} {{
        $t('Operator') }}</el-button>
      <!-- <el-button type="primary" class="mr10" icon="el-icon-refresh" @click="handleQuery()">刷新</el-button> -->
      <!-- <el-button type="primary" icon="el-icon-plus" class="mr10" @click="handleAdd()">{{$t('Add')}}</el-button> -->
    </div>
    <div>
      <el-table :data="table_data" border class="table" max-height="700px" :cell-style="{ padding: '0' }">
        <el-table-column align="center" prop="SellerId" :label="$t('Operator')" width="100"></el-table-column>
        <el-table-column align="center" prop="SellerName" :label="$t('OperatorName')" width="150"></el-table-column>
        <el-table-column align="center" :label="$t('Status')" width="100">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" v-if="scope.row.State == 1">{{ $t('Enable') }}</el-link>
            <el-link :underline="false" type="danger" v-if="scope.row.State == 2">{{ $t('Disable') }}</el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="Remark" :label="$t('Remarks')" width="300"></el-table-column>
        <el-table-column align="center" prop="CreateTime" :label="$t('CreationTime')" width="150"></el-table-column>
        <el-table-column :label="$t('Actions')" min-width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleModify(scope.$index)">{{ $t('modify') }}</el-button>
            <!-- <el-button type="text" icon="el-icon-edit"
              @click="openSellerSetting(scope.row, '底部导航配置')">底部导航配置</el-button> -->
            <el-button type="text" icon="el-icon-edit" @click="openCurrencyConfig(scope.row)">币种配置</el-button>
            <!-- <el-button type="text" icon="el-icon-edit"
              @click="openSellerSetting(scope.row, '奖金余额规则')">奖金余额规则</el-button>
            <el-button type="text" icon="el-icon-edit"
              @click="openSellerSetting(scope.row, '注册&登录方式')">注册&登录方式</el-button>
            <el-button type="text" icon="el-icon-edit"
              @click="openSellerSetting(scope.row, '实名方式配置')">实名方式配置</el-button>
            <el-button type="text" icon="el-icon-sort"
              @click="openSellerSetting(scope.row, '充值分类排序')">充值分类排序</el-button> -->
            <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index)">{{ $t('Delete')
              }}</el-button>
            <el-button type="text" icon="el-icon-refresh" @click="resetWebclip(scope.$index)">重置Webclib</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination style="margin-top: 5px" background layout="total, prev, pager, next, jumper" :current-page="page"
          :total="total" @current-change="handleQuery" :page-size="pagesize"></el-pagination>
      </div>
    </div>
    <div>
      <el-dialog :title="dialog.title" :visible.sync="dialog.show" width="400px" center>
        <el-form :inline="true" label-width="100px">
          <el-form-item :label="$t('operatorName') + ':'">
            <el-input v-model="dialog.data.SellerName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('options') + ':'">
            <el-checkbox border :label="$t('disable')" v-model="dialog.data.State" :true-label="2"
              :false-label="1"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('notes') + ':'">
            <el-input type="textarea" v-model="dialog.data.Remark" :rows="4"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">{{ $t('sure') }}</el-button>
        </span>
      </el-dialog>
    </div>
    <SystemAddSeller v-if="mAddSellerData.show" :dialogData="mAddSellerData" @success="handleQuery" />
    <el-dialog :title="mSellerConfigData.title" :visible.sync="mSellerConfigData.show" :width="sellerConfigDialogWidth"
      :top="sellerConfigDialogTop" center :close-on-click-modal="false" append-to-body :class="[
        'seller-config-dialog',
        { 'seller-currency-dialog-wrapper': mSellerConfigData.type == 'currency' },
      ]">
      <SellerCurrencyConfigDialog v-if="mSellerConfigData.show && mSellerConfigData.type == 'currency'"
        :seller-id="mSellerConfigData.row.SellerId" @close="mSellerConfigData.show = false" />
      <SystemConfig v-if="mSellerConfigData.show && mSellerConfigData.type == 'setting'"
        :seller-id="mSellerConfigData.row.SellerId" :config-remark="mSellerConfigData.remark" embedded />
    </el-dialog>
  </div>
</template>
<script>
import { app } from "@/api/app.js";
import "@/assets/css/k.css";
import base from "@/api/base.js";
import SystemAddSeller from "./dialog/SystemAddSeller.vue";
import SellerCurrencyConfigDialog from "./dialog/SellerCurrencyConfigDialog.vue";
import SystemConfig from "./config.vue";
export default {
  extends: base,
  name: "systemSeller",
  components: { SystemAddSeller, SellerCurrencyConfigDialog, SystemConfig },
  data() {
    return {
      sellerState: 0,
      dialog: {
        data: {
          SellerName: null,
          State: 1,
          Remark: null,
        },
      },
      mAddSellerData: {
        title: this.$t(' operator.new'),
        show: false,
        row: {},
        opt: 1, // 1 新增 2 修改
      },
      mSellerConfigData: {
        title: "",
        show: false,
        row: {},
        type: "",
        remark: "",
      },
    };
  },
  created() {
    this.handleQuery();
  },
  computed: {
    sellerConfigDialogWidth() {
      return this.mSellerConfigData.type == "currency" ? "1184px" : "92%";
    },
    sellerConfigDialogTop() {
      return this.mSellerConfigData.type == "currency" ? "0" : "5vh";
    },
  },
  methods: {
    OnClickAddSeller() {
      this.mAddSellerData.opt = 1;
      this.mAddSellerData.title = this.$t('operator.new');
      this.mAddSellerData.row = {};
      this.mAddSellerData.show = true;
    },
    handleQuery(page) {
      this.page = page || 1;
      if (typeof this.page == "object") this.page = 1;
      var data = {
        page: this.page,
        pagesize: this.pagesize,
        State: Number(this.sellerState || 0),
      };
      app.post("/admin/seller/list", data, (result) => {
        this.table_data = result.data.data;
        this.total = result.data.total;
        for (var i = 0; i < this.table_data.length; i++) {
          this.table_data[i].CreateTime = this.$moment(
            this.table_data[i].CreateTime
          ).format("YYYY-MM-DD HH:mm:ss");
        }
      });
    },
    handleAdd() {
      this.dialog.type = "add";
      this.dialog.data.SellerName = null;
      this.dialog.data.State = 1;
      this.dialog.data.Remark = null;
      this.dialog.title = this.$t('operator.add');
      this.dialog.show = true;
    },
    handleModify(index) {
      // this.dialog.type = "modify";
      // this.dialog.title = "修改运营商";
      // this.current_row = index;
      // this.dialog.data = app.clone(this.table_data[index]);
      // this.dialog.show = true;
      this.mAddSellerData.opt = 2;
      this.mAddSellerData.title = this.$t('operator.revise');
      this.mAddSellerData.row = app.clone(this.table_data[index]);
      this.mAddSellerData.show = true;
    },
    handleConfirm() {
      if (this.dialog.type == "modify") {
        this.dialog.data.IgnoreSeller = true;
        app.post("/admin/seller/modify", this.dialog.data, () => {
          app.flushSeller();
          this.dialog.show = false;
          this.handleQuery(this.page);
        });
      }
      if (this.dialog.type == "add") {
        app.post("/admin/seller/add", this.dialog.data, () => {
          app.flushSeller();
          this.dialog.show = false;
          this.handleQuery(this.page);
        });
      }
    },
    openCurrencyConfig(row) {
      this.mSellerConfigData.title = "币种配置";
      this.mSellerConfigData.row = app.clone(row);
      this.mSellerConfigData.type = "currency";
      this.mSellerConfigData.remark = "";
      this.mSellerConfigData.show = true;
    },
    openSellerSetting(row, remark) {
      this.mSellerConfigData.title = `${remark} - ${row.SellerName}`;
      this.mSellerConfigData.row = app.clone(row);
      this.mSellerConfigData.type = "setting";
      this.mSellerConfigData.remark = remark;
      this.mSellerConfigData.show = true;
    },
    handleDelete(index) {
      if (confirm(this.$t('operator.delete'))) {
        app.post(
          "/admin/seller/delete",
          { SellerId: this.table_data[index].SellerId, IgnoreSeller: true },
          () => {
            app.flushSeller();
            this.handleQuery(this.page);
          }
        );
      }
    },
    resetWebclip(index) {
      if (confirm("确定重置该运营商的IOS Webclib描述文件？")) {
        app.post("/admin/seller/upwebclip", { SellerId: this.table_data[index].SellerId }, (res) => {
          if (res.code == 200) {
            this.$message({
              message: "重置成功",
              type: "success"
            })
          }
        })
      }
    }
  },
};
</script>
<style scoped>
.seller-filter-label {
  color: #606266;
  font-size: 14px;
}

.seller-state-filter {
  width: 120px;
  margin-right: 10px;
}

.seller-config-dialog ::v-deep .el-dialog__body {
  max-height: 78vh;
  overflow-y: auto;
  padding: 10px 20px 20px;
}

.seller-config-dialog ::v-deep .embedded-page {
  min-height: auto;
  border: 0;
  padding: 0;
}

.seller-currency-dialog-wrapper ::v-deep .el-dialog__header {
  padding: 22px 20px 14px;
}

.seller-currency-dialog-wrapper ::v-deep .el-dialog__title {
  color: #303133;
  font-size: 18px;
  font-weight: 500;
}

.seller-currency-dialog-wrapper ::v-deep .el-dialog__body {
  max-height: calc(100vh - 62px);
  overflow-y: auto;
  padding: 22px 0 18px;
}
</style>
